import {
  TrendingUp,
  Building2,
  Factory,
  Zap,
  Briefcase,
  LucideProps,
} from "lucide-react";
import { cn } from "@/lib/utils";

interface ProviderIconProps {
  iconType: string;
  size?: number;
  className?: string;
}

const iconMap: Record<string, React.FC<LucideProps>> = {
  trending: TrendingUp,
  building: Building2,
  factory: Factory,
  zap: Zap,
  briefcase: Briefcase,
};

export const ProviderIcon = ({
  iconType,
  size = 24,
  className,
}: ProviderIconProps) => {
  const IconComponent = iconMap[iconType] || TrendingUp;

  return <IconComponent size={size} className={cn(className)} />;
};
